import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { URL, getToken } from "../../../utils";

const DeactivateModal = ({
  currentPoint,
  closeModal,
  fetchData,
  loading,
  setLoading,
}) => {
  const token = getToken();

  const handleDeactivate = async () => {
    setLoading(true);

    try {
      const response = await axios.patch(
        `${URL}Magasins/deactivate-magasin/${currentPoint.id}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        fetchData();
        closeModal();
        toast.success("Point de vente désactivé avec succès !");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error ||
          "Une erreur s'est produite lors de la désactivation."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed top-0 left-0 inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute top-0 left-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm"
        onClick={closeModal}
      />

      <div className="relative bg-white rounded-lg shadow w-full max-w-md mx-4">
        <button
          type="button"
          onClick={closeModal}
          className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center"
        >
          ✕
        </button>

        <div className="p-6">
          <div className="flex items-center gap-4 mb-4">
            <svg
              className="w-8 h-8 text-red-500"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="2"
                d="m6 6 12 12m3-6a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>

            <h3 className="text-xl font-semibold">
              Désactiver ce point de vente
            </h3>
          </div>

          <p className="mb-6 text-gray-600">
            Êtes-vous sûr de vouloir désactiver{" "}
            <strong>{currentPoint.nom}</strong> ? Cette action est réversible.
          </p>

          <div className="grid grid-cols-2 gap-4">
            <button
              type="button"
              onClick={handleDeactivate}
              disabled={loading}
              className="py-2 px-4 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors flex justify-center items-center"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white rounded-full animate-spin" />
              ) : (
                "Désactiver"
              )}
            </button>

            <button
              type="button"
              onClick={closeModal}
              disabled={loading}
              className="py-2 px-4 bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 rounded-md transition-colors"
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(DeactivateModal);
